import { Configuration } from '@DigitaleDoerfer/digitale-doerfer-api';
import { API_DD_SERVICE_URL } from 'configs';
import { useGetApiConfig } from 'hooks';

export const useGetDDServiceApiConfiguration = () => {
  const apiConfig = useGetApiConfig(API_DD_SERVICE_URL);

  return new Configuration(apiConfig);
};
